import { render, staticRenderFns } from "./PaymentPreferenceListComponent.vue?vue&type=template&id=69749719&"
import script from "./PaymentPreferenceListComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentPreferenceListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports